const DLMR01V101 = async () => await import('@/views/dlmr/DLMR-01-V101.vue')
const DLMR06V101 = async () => await import('@/views/dlmr/DLMR-06-V101.vue')
const DLMR06V201 = async () => await import('@/views/dlmr/DLMR-06-V201.vue')
const DLMR06V301 = async () => await import('@/views/dlmr/DLMR-06-V301.vue')
const DLMR07V101 = async () => await import('@/views/dlmr/DLMR-07-V101.vue')
const DLMR07V201 = async () => await import('@/views/dlmr/DLMR-07-V201.vue')

export const routerDlmr = [
  {
    path: '/dlmr/DLMR-01-V101',
    component: DLMR01V101,
    name: 'DLMR-01-V101',
    meta: {
      header: {
        back: true,
        myPage: false,
        refresh: false,
        home: false
      },
      title: '회원가입',
      code: 'DLMR-01-V101',
      tabName: '회원가입',
      requireAuth: false
    }
  },
  {
    path: '/dlmr/DLMR-06-V101',
    component: DLMR06V101,
    name: 'DLMR-06-V101',
    meta: {
      header: {
        back: true,
        myPage: false,
        refresh: false,
        home: false
      },
      title: '아이디 찾기',
      code: 'DLMR-06-V101',
      tabName: '아이디 찾기',
      requireAuth: false
    }
  },
  {
    path: '/dlmr/DLMR-06-V201',
    component: DLMR06V201,
    name: 'DLMR-06-V201',
    meta: {
      header: {
        back: true,
        myPage: false,
        refresh: false,
        home: false
      },
      title: '아이디 찾기',
      code: 'DLMR-06-V201',
      tabName: '아이디 찾기',
      requireAuth: false
    }
  },
  {
    path: '/dlmr/DLMR-06-V301',
    component: DLMR06V301,
    name: 'DLMR-06-V301',
    meta: {
      header: {
        back: true,
        myPage: false,
        refresh: false,
        home: false
      },
      title: '아이디 찾기',
      code: 'DLMR-06-V301',
      tabName: '아이디 찾기',
      requireAuth: false
    }
  },
  {
    path: '/dlmr/DLMR-07-V101',
    component: DLMR07V101,
    name: 'DLMR-07-V101',
    meta: {
      header: {
        back: true,
        myPage: false,
        refresh: false,
        home: false
      },
      title: '비밀번호 찾기',
      code: 'DLMR-07-V101',
      tabName: '비밀번호 찾기',
      requireAuth: false
    }
  },
  {
    path: '/dlmr/DLMR-07-V201',
    component: DLMR07V201,
    name: 'DLMR-07-V201',
    meta: {
      header: {
        back: true,
        myPage: false,
        refresh: false,
        home: false
      },
      title: '비밀번호 찾기',
      code: 'DLMR-07-V201',
      tabName: '비밀번호 찾기',
      requireAuth: false
    }
  }
]
